export default "__VITE_ASSET__DHoEzlI___"